// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1471":"db89e4f4","1676":"029fec2c","2086":"90d9dc9d","3943":"4de79847","4036":"31d6cfe0"}[chunkId] + ".chunk.css";
};